import React from 'react'

export default function ContractorAnalytic({ }) {
  return <div>ContractorAnalytic</div>
}